<template>
  <div class="wrap">
    <div class="navbar">
      <div class="navbar_left">
        <van-icon name="arrow-left" size="20" color="#fff" />
      </div>
      <div class="navbar_center" @click.stop="openMenu = true">
        {{ configs?.title || '' }}
        <i class="iconfont icon-xiangxia"></i>
      </div>
      <div class="navbar_right"></div>
    </div>
    <div class="wrap_cont">
      <div class="issure_card app_card">
        <div class="issure_card_top">
          <div class="issure_card_top_left">{{ $t('第某期', { _: currentGame.expect }) }}</div>
          <div class="issure_card_top_right">{{ $t('投注中') }}</div>
        </div>
        <div class="card_result">
          <div class="card_result_left">
            <div class="left_expect">
              {{ $t('上期') }} {{ lastCurrent?.expect }}
            </div>
            <template v-if="lastCurrent?.open?.dwd">
              <div class="left_result">
                <div class="ball_wraps" v-if="type.indexOf('hl') != '-1'">
                  <div class="ball_img" v-for="item, index in lastCurrent?.open?.dwd" :key="index">
                    <img class="img" :src="require(`@/assets/icon/dice/${item}.png`)" alt="">
                  </div>
                </div>
                <div class="ball_wrap" v-else>
                  <div class="ball" v-for="item, index in lastCurrent?.open?.dwd" :key="index">
                    {{ item }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else>

            </template>
          </div>
          <div class="card_result_right" v-if="type != 'xyft' && type != 'bjsc'">
            <div class="card_result_right_sum">{{ $t('和值') }}</div>
            <div class="card_result_right_val">{{ sumVal }}</div>
          </div>
        </div>
        <div class="card_fot">
          <div class="fot_left">{{ $t('距离封盘') }}</div>
          <div class="fot_time">{{ countText }}</div>
        </div>
      </div>
      <div class="banner app_card">
        <Banner position="aiBet" :bannerArr="bannerArr" @itemClick="swiperClick" />
      </div>
      <div class="wrap_conts">
        <div class="tab">
          <div class="tab_item" :class="tabNum == index ? 'tab_item_active' : ''" v-for="item, index in tabArr"
            :key="index" @click="tabClick(index)">
            {{ $t(item) }}
          </div>
        </div>
        <template v-if="tabNum == 0">
          <aiPrediction ref="aiPredictionRef" :configs="configs" />
        </template>
        <template v-else>
          <aiMyBetting ref="aiMyBettingRef" :configs="configs" />
        </template>
      </div>
    </div>
    <van-popup class="menu_popup" v-model="openMenu" position="bottom" @click.stop="openMenu = false">
      <div class="menu" @click.stop>
        <div class="menu_list" :class="item.type == type ? 'menu_active' : ''" v-for="item, index in merchants"
          :key="index" @click="merchantsClick(item)">{{ item.title
          }}
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Navbar from "@/components/JNav";
import { Icon, Popup, Toast } from 'vant';
import { $post, $get, cancelAllRequests } from "@/utils/request";
import aiPrediction from "./ai_prediction.vue";
import aiMyBetting from "./ai_my_betting.vue";
import Banner from "@/components/banner.vue";
export default {
  components: {
    Navbar,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    Toast,
    aiPrediction,
    aiMyBetting,
    Banner
  },
  data() {
    return {
      bannerArr: [],
      isVisible: true,
      openMenu: false,
      type: '',
      configs: {},
      currentGame: {},
      lastCurrent: {},
      timer: null,
      timer1: null,
      interval: null,
      countText: "00:00",
      countTime: 0,
      sumVal: '--',
      tabArr: ['AI智能预测', 'AI智能投注'],
      tabNum: 0
    }
  },
  computed: {
    merchants() {
      let game = this.$store.getters.AllGameList;
      return game
    },
  },
  watch: {
    merchants: {
      handler(game) {
        if (!game || !game.length) return
        this.configs = game[0]
        this.type = this.configs?.type

        if (this.type) this.getOrders()
      },
      immediate: true
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  methods: {
    swiperClick(item, index) {
      if (item.action === 'goto_sale') {
        if (item.paramet && item.paramet.url) {
          return this.$router.push(`/ActivityDetails?id=${item.paramet.url}`)
        }
        this.$router.push('/activity')
      } else if (item.action === 'web_system') {
        if (item.paramet && item.paramet.url) {
          window.location.href = item.paramet.url
        }
      } else if (item.action === 'lottery_room') {
        if (item.paramet && item.paramet.lottery_type) {
          this.toGame({ type: item.paramet.lottery_type })
        }
      } else if (item.action == 'open_agent') {
        this.$router.push('/agent')
      } else if (item.action == 'toast') {
        if (item.paramet && item.paramet.toast) {
          this.$toast(item.paramet.toast)
        }
      }
    },
    getBanner() {
      this.$api.getBanner((res) => {
        this.bannerArr = res
      }, (err) => { }, 'aiBet')
    },
    tabClick(index) {
      this.tabNum = index;
    },
    handleVisibilityChange() {
      this.isVisible = !document.hidden;
      if (!this.isVisible) {
      } else {
        this.getOrders();
        this.$store.dispatch('getuserInfo')
      }
    },
    merchantsClick(item) {
      this.configs = item
      this.type = item.type;
      this.openMenu = false;
      clearInterval(this.interval);
      clearTimeout(this.timer);
      clearTimeout(this.timer1);
      this.timer = null;
      this.interval = null
      this.timer1 = null;
      this.$nextTick(() => {
        this.getOrders();
        if (this.tabNum == 1) {
          this.$refs.aiMyBettingRef.getOrder();
        } else {
          // this.$refs.aiPredictionRef.getOrder();
        }
      })
    },
    async getOrders(pageSize = 2, flag = false, callback = () => { }) {
      // Toast.loading();
      try {
        const res = await $get("/lottery/lists", {
          type: this.type,
          pagesize: pageSize,
        });
        const { ret, msg, data } = res.data;
        const current = data.lists[0];
        this.$nextTick(() => {
          this.currentGame = current;
          this.lastCurrent = data.lists[1];
          this.sumVal = (this.lastCurrent?.open?.dwd && this.lastCurrent.open.dwd.reduce((acc, x) => acc + Number(x), 0))
        })
        callback();
        if (!flag) {
          this.addInterval(current.countdown, current, data.lists[1]);
        }
        Toast.clear();
      } catch (error) {
        Toast.clear();
      }
    },
    addInterval(countTime, item, item1) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null
      }
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null
      }
      if (!Number(countTime)) {
        this.countText = this.$t("status.open");
        this.timer1 = setTimeout(() => {
          this.getOrders();
          if (this.tabNum == 1) {
            this.$refs.aiMyBettingRef.getOrder();
          } else {
            this.$refs.aiPredictionRef.getOrder();
          }
          this.num = 0;
        }, (item.opentime - item.endtime) * 1000);
        return;
      }
      if (Number(countTime) && !item1.open.dwd) {
        this.timer1 = setTimeout(() => {
          this.getOrders();
          if (this.tabNum == 1) {
            this.$refs.aiMyBettingRef.getOrder();
          } else {
            this.$refs.aiPredictionRef.getOrder();
          }
        }, (item.opentime - item.endtime) * 1000);
        return;
      }
      this.countTime = countTime;
      this.intervalFun();
      this.interval = setInterval(() => {
        this.countTime--;
        this.intervalFun();
      }, 1000);
    },
    format(num) {
      if (num >= 10) return num;
      else return "0" + num;
    },
    intervalFun() {
      const hourUnit = 60 * 60;
      const minuteUnit = 60;
      const secondUnit = 1;
      const targetH = Math.floor(this.countTime / hourUnit);
      const targetM = Math.floor((this.countTime % hourUnit) / minuteUnit);
      const targetS = Math.floor(
        ((this.countTime % hourUnit) % minuteUnit) / secondUnit
      );
      if (!this.countTime) {
        clearInterval(this.interval);
        this.getOrders();
        if (this.tabNum == 1) {
          this.$refs.aiMyBettingRef.getOrder();
        } else {
          this.$refs.aiPredictionRef.getOrder();
        }
      }
      this.countText = `${this.format(
        targetM
      )}:${this.format(targetS)}`;
    },
  },
  created() {
    this.getBanner();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearTimeout(this.timer);
    clearTimeout(this.timer1);
    this.timer = null;
    this.interval = null
    this.timer1 = null;
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    cancelAllRequests()
  },
  destroyed() {
    clearInterval(this.interval);
    clearTimeout(this.timer);
    clearTimeout(this.timer1);
    this.timer = null;
    this.interval = null
    this.timer1 = null;
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    cancelAllRequests();
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: calc(100vh - 50px - 24px);
  background: radial-gradient(circle at top right, rgba(24, 179, 141, .12), transparent 26%), radial-gradient(circle at left 25%, rgba(47, 110, 246, .1), transparent 22%), linear-gradient(180deg, #f7f9fc, #eef2f7);
  padding: 12px;

  .navbar {
    height: 56px;
    background: linear-gradient(180deg, #0f1321fa, #2a3143fa);
    color: var(--light);
    box-shadow: 0 12px 24px #0f172a2e;
    padding: 0 12px;
    margin: -12px -12px 0;
    display: flex;
    align-items: center;

    .navbar_left {
      width: 24px;
      height: 34px;
      padding: 1px 6px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .navbar_center {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .navbar_right {
      width: 36px;
      height: 36px;
    }
  }

  .wrap_cont {
    padding-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .issure_card {
      padding: 14px;
      border-radius: 22px;
      background: linear-gradient(180deg, #3a4152, #2b3140);
      color: #fff;
      box-shadow: 0 18px 28px #0f172a24;

      .issure_card_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;

        .issure_card_top_left {
          color: var(--light);
          font-size: 14px;
          font-weight: 600;
        }

        .issure_card_top_right {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 6px 12px;
          border-radius: 999px;
          border: 1px solid #1fe1a53d;
          background: #ffffff14;
          font-size: 12px;
          color: #1fe1a5;
          background: #1fe1a514;
        }
      }

      .card_result {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 12px;
        padding: 12px 0;
        border-top: 1px solid rgba(255, 255, 255, .06);
        border-bottom: 1px solid rgba(255, 255, 255, .06);
        align-items: stretch;

        .card_result_left {
          display: flex;
          flex-direction: column;
          gap: 8px;

          .left_expect {
            color: #ffffff9e;
            font-size: 14px;
            font-weight: 600;
          }

          .left_result {
            .ball_wraps {
              display: flex;
              flex-wrap: wrap;
              gap: 10px;

              .ball_img {
                img {
                  width: 38px;
                  height: 38px;
                  display: block;
                }
              }
            }

            .ball_wrap {
              display: flex;
              flex-wrap: wrap;
              gap: 10px;

              .ball {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 38px;
                height: 38px;
                border-radius: 999px;
                background: linear-gradient(180deg, #ffdf7b, #ff7b4a);
                color: #5a1900;
                font-size: 18px;
                font-weight: 900;
                box-shadow: 0 8px 16px rgba(255, 126, 70, .24);
              }
            }

          }
        }

        .card_result_right {
          color: #fff;
          box-shadow: 0 18px 28px #0f172a24;
          flex-shrink: 0;
          width: 80px;
          height: fit-content;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #ffffff0d;
          border-radius: 14px;
          padding: 10px 8px;

          .card_result_right_sum {
            font-size: 16px;
            font-weight: 600;
          }

          .card_result_right_val {
            margin-top: 6px;
            font-size: 14px;
          }
        }
      }

      .card_fot {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-top: 12px;

        .fot_left {
          font-size: 14px;
          color: #ffffffb8;
        }

        .fot_time {
          font-size: 32px;
          font-weight: 900;
          color: #ff5162;
          line-height: 1;
        }
      }
    }

    .banner {
      width: 100%;

      img {
        width: 100%;
        display: block;
      }
    }

    .wrap_conts {
      .tab {
        display: flex;
        padding-bottom: 12px;

        .tab_item {
          flex: 1;
          font-size: 16px;
          color: #6b7280;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 0 5px;
          line-height: 1;
          font-weight: 600;
        }

        .tab_item_active {
          position: relative;
          color: #2f82ff;

          &::before {
            position: absolute;
            content: '';
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            height: 3px;
            border-radius: 100px;
            width: 20px;
            background: #2f82ff;
          }
        }
      }
    }
  }

  .menu_popup {
    // background-color: transparent;
    border-radius: 10px 10px 0 0;

    .menu {
      margin: 0 auto;
      // border-radius: 10px 10px 0 0;
      overflow: hidden;
      // background: var(--navBg);
      // box-shadow: 0 5px 10px 0 rgba(255, 0, 16, .4);

      .menu_list {
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        color: #323233;
        text-align: center;
        font-size: calc(14rem / 16);
      }

      .menu_active {
        background: var(--btn_bg);
        color: var(--light);
      }
    }
  }
}
</style>